export default __webpack_public_path__ + "static/media/Group8872.bb86f2d4.svg";